import {connect} from 'react-redux';
import React from 'react';
import {
    SCRATCH_UPLOAD_STATUS,
    SCRATCH_UPLOAD_STATUS_CHANGED,
    SCRATCH_UPLOAD_STATUS_KEY,
    getScratchUploadStatus
} from '../../lib/scratch-upload-status';
import savingStatusIcon from './status-icons/saving-status.svg';
import savedStatusIcon from './status-icons/saved-status.svg';

import styles from './save-status.css';

// Show a Google Sheets-style saving/saved state based on local upload status.
class SaveStatus extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            uploadStatus: getScratchUploadStatus()
        };
        this.handleUploadStatusChanged = this.handleUploadStatusChanged.bind(this);
        this.handleStorageChanged = this.handleStorageChanged.bind(this);
        this.syncUploadStatus = this.syncUploadStatus.bind(this);
    }

    componentDidMount () {
        this.syncUploadStatus();
        if (typeof window !== 'undefined') {
            window.addEventListener(SCRATCH_UPLOAD_STATUS_CHANGED, this.handleUploadStatusChanged);
            window.addEventListener('storage', this.handleStorageChanged);
        }
    }

    componentWillUnmount () {
        if (typeof window !== 'undefined') {
            window.removeEventListener(SCRATCH_UPLOAD_STATUS_CHANGED, this.handleUploadStatusChanged);
            window.removeEventListener('storage', this.handleStorageChanged);
        }
    }

    handleUploadStatusChanged (event) {
        const nextStatus = event && event.detail;
        if (
            nextStatus === SCRATCH_UPLOAD_STATUS.SAVED ||
            nextStatus === SCRATCH_UPLOAD_STATUS.SAVING
        ) {
            this.setState({uploadStatus: nextStatus});
            return;
        }
        this.syncUploadStatus();
    }

    handleStorageChanged (event) {
        if (event.key === SCRATCH_UPLOAD_STATUS_KEY) {
            this.syncUploadStatus();
        }
    }

    syncUploadStatus () {
        this.setState({
            uploadStatus: getScratchUploadStatus()
        });
    }

    render () {
        const isSaving = this.state.uploadStatus === SCRATCH_UPLOAD_STATUS.SAVING;
        const statusText = isSaving ? 'Saving.....' : 'Saved';
        const statusIcon = isSaving ?
            savingStatusIcon :
            savedStatusIcon;

        return (
            <div
                className={styles.saveNow}
                style={{
                    cursor: 'default',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.35rem',
                    color: '#fff',
                    pointerEvents: 'auto'
                }}
            >
                {statusIcon ? (
                    <img
                        alt={isSaving ? 'Saving status icon' : 'Saved status icon'}
                        src={statusIcon}
                        style={{width: '0.85rem', height: '0.85rem'}}
                    />
                ) : null}
                {statusText}
            </div>
        );
    }
}

export default connect(
    null
)(SaveStatus);
